import { render, staticRenderFns } from "./customEmailInput.vue?vue&type=template&id=4cf85caf&scoped=true"
import script from "./customEmailInput.vue?vue&type=script&lang=js"
export * from "./customEmailInput.vue?vue&type=script&lang=js"
import style0 from "./customEmailInput.vue?vue&type=style&index=0&id=4cf85caf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf85caf",
  null
  
)

export default component.exports